const hasOwnProperty = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property);

export const getOwnProperty = (obj, property, fallbackValue = undefined) => (
  // eslint-disable-next-line security/detect-object-injection
  hasOwnProperty(obj, property) ? obj[property] : fallbackValue
);

export default hasOwnProperty;
